export enum SensorDataTypeEnum {
    ParticulateTimeseries = "particulate-timeseries",
    OpcR2 = "opc-r2",
    NoiseTimeseries = "noise-timeseries",
    AirNowMonitoring = "AirNowMonitoringSiteObservations",
    GasData = "GasData",
    TrolexSensorRecords = "TrolexSensorRecords",
}
